import React from 'react'


interface SvgIconProps {
    icon: {
        path: { d: string }[]
        viewBox: string
    }
    width?: number | string
    height?: number | string
    fill?: string
    className?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({
    icon,
    width = 24,
    height = 24,
    fill = 'currentColor',
    className,
}) => {
    return (
        <svg
            viewBox={icon.viewBox}
            width={width}
            height={height}
            fill={fill}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            {icon.path.map((p, i) => (
                <path key={i} d={p.d} />
            ))}
        </svg>
    )
}

export default SvgIcon
